class MainBlog extends HTMLElement {
  constructor() {
    super();
    this.id = this.dataset.id;
    this.tagLinks = this.querySelectorAll("[data-tag-link");
    this.handleClick = this.handleClick.bind(this);
    this.addEventListener("click", this.handleClick);

    this.tagLinks.forEach((link) => link.addEventListener("click", (e) => this.handleLinkClick(e)));
  }

  async handleClick(e) {
    const isTagLink = e.target.classList.contains("main-blog__tab");

    if (isTagLink) {
      this.handleLinkClick(e);
    }
  }

  handleLinkClick(event) {
    event.preventDefault();

    this.renderPage(event.target.dataset.url);
  }

  renderPage(url) {
    this.setLoading();
    const fetchUrl = `${url}?section_id=${this.id}`;
    this.renderArticles(fetchUrl, event);
    this.updateURLHash(url);
  }

  renderArticles(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderContent(html);
        this.setDoneLoading();
      });
  }

  renderContent(html) {
    this.querySelector("[data-content]").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector("[data-content]").innerHTML;
  }

  setLoading() {
    this.querySelector("[data-blog-grid]").classList.add("loading");
  }

  setDoneLoading() {
    this.querySelector("[data-blog-grid]").classList.remove("loading");
  }

  updateURLHash(url) {
    window.history.replaceState({}, "", url);
  }
}

if (!customElements.get("main-blog")) {
  customElements.define("main-blog", MainBlog);
}
